import { yupResolver } from '@hookform/resolvers/yup';
import { AxiosError } from 'axios';
import { ChangeEvent, useState } from 'react';
import { useForm } from 'react-hook-form';
import { useNavigate, useSearchParams } from 'react-router-dom';
import * as Yup from 'yup';
import StickButtonsBloc from '../../blocs/common/StickButtonsBloc';
import { APP_URLS, ERROR_MESSAGES, MAX_SMALL_MOBILE_WIDTH, PROPOSITION_DOC_TYPES } from '../../const/AppConst';
import useAppState from '../../context/AppContext';
import { IApiErrors, IDocumentDetail } from '../../context/model';
import MgpMessage from '../../elements/MgpMessage/MgpMessage';
import LoaderModal from '../../modals/common/LoaderModal';
import UploadFilePreviewModal from '../../modals/common/UploadFilePreviewModal';
import { downloadUploadedDocument, replaceDocument } from "../../services/CustomerApiService";
import QrCodeModal from '../../modals/common/QrCodeModal';
import useWindowDimensions from '../../hooks/useWindowDimensions';
import { getCompressFile, getFilename, handleKeyDown, isAcceptedFileSize, isValidFileSize, isValidFileType } from '../../utils/utils';
import ListOfFileUploaded from '../common/ListOfFileUploaded';
import MgpInputFileUpload from '../../elements/MgpInputFileUpload/MgpInputFileUpload';
import UploadFromPhoneButton from '../common/UploadFromPhoneButton';

type UploadDocumentFormData = {

}

export default function UploadDocumentFormComponent() {

  const {
    state: { proposition, jwtToken },
    dispatch,
  } = useAppState();

    const navigate = useNavigate();

  const validationSchema = Yup.object().shape({
   
  });
  
  const [errorMsg, setErrorMsg] = useState<string | null>();
  
  const [errorFileTypeMsg, setErrorFileTypeMsg] = useState<boolean | null>();
  const [errorFileSizeMsg, setErrorFileSizeMsg] = useState<boolean | null>();
  const [loading, setLoading] = useState<boolean>(false);
  const [file, setFile] = useState<File | null>(null);
  const [openPreviewFile, setOpenPreviewFile] = useState<boolean>(false);
  const [isShowModal, setIsShowModal] = useState<boolean>(false);
  const [showUploadButtonOnModal, setShowUploadButtonOnModal] = useState<boolean>(false);
  const [documentUploaded, setDocumentUploaded] = useState<any>();


  const {width} = useWindowDimensions();
  const isDesktop = width > MAX_SMALL_MOBILE_WIDTH;

  const [searchParams] = useSearchParams();

  const documentCategory = searchParams.get("documentCategory");
  const documentId = searchParams.get("documentId") ?? '';
  const documentTypeCode = searchParams.get("documentTypeCode") ?? '';

  let invalidMessage;

  if (documentCategory === "rib") {
      invalidMessage = "Votre RIB est invalide. Veuillez vérifier que le RIB est bien lisible et que vous êtes le titulaire du compte.";
  } else if (documentCategory === "attestation-sociale") {
      invalidMessage = "Votre attestation de sécurité sociale est invalide. Veuillez vérifier qu'elle est bien lisible et en cours de validité.";
  } else {
      invalidMessage = "Votre document est invalide. Veuillez vérifier qu'il est bien lisible et en cours de validité.";
  }

  const showQrCodeNotPrincipal= () => {
    setIsShowModal(true);
  }

  const showQrCodeModal = () => {
    setIsShowModal(true);
  }
  const closeModal = () => {
    setIsShowModal(false)
  }

  const handleFileChange = async (event: ChangeEvent<HTMLInputElement>) => {
    try {
      const uploadedfile = event.target.files ? event.target.files[0] : null;
    
      if (uploadedfile) {
        if(!isValidFileType(uploadedfile)) {
          setErrorFileTypeMsg(true)
        } else if(!isValidFileSize(uploadedfile)) {
          setErrorFileSizeMsg(true)
        } else if (!isAcceptedFileSize(uploadedfile)) {
          try {
            const token = jwtToken!.accessToken;
            const newFile = await getCompressFile(token, uploadedfile);
            setFile(newFile);
            setOpenPreviewFile(true);
            setShowUploadButtonOnModal(true);
            dispatch({type: 'SHOW_MODAL', showModal: true});   
          }  catch(e) {
            setErrorMsg("Suite à un incident technique, nous ne pouvons pas uploader votre fichier. Veuillez sélectionner à nouveau.");
          } 
          
        } else {
          setFile(uploadedfile);
          setOpenPreviewFile(true);
          setShowUploadButtonOnModal(true);
          dispatch({type: 'SHOW_MODAL', showModal: true});
        }
      }
    } catch (error) {
      const err = error as AxiosError;
      console.log(err);
      if(err.response && err.response.status === 400) {
        const errorData = err.response?.data as IApiErrors;
        setErrorMsg("Erreur: " + errorData.message);
      } else {
        setErrorMsg("Une erreur technique est survenue ");
      }
    }  
  };


  const {
    register,
    formState: { errors, isSubmitting },
  } = useForm<UploadDocumentFormData>({
    mode: "onBlur",
    reValidateMode: "onChange",
    defaultValues: {
    },
    resolver: yupResolver(validationSchema),
  });

  const onUploadAction = async () => {
    setErrorMsg(null);
    setErrorFileTypeMsg(false);
    setErrorFileSizeMsg(false);
    setLoading(true);
    try {
      const token = jwtToken!.accessToken;
      const res = await replaceDocument(token, proposition!.propositionId, documentId, file as File, false);
 
      setLoading(false);
      setDocumentUploaded(res.data);
      const updatedDocuments = proposition?.documents ?  [...proposition?.documents] as IDocumentDetail[] : [];
      const index = updatedDocuments.findIndex(el => el.documentId === documentId);
      updatedDocuments.splice(index, 1, res.data)
      dispatch({type: 'UPDATE_UPDATED_DOCUMENTS', updatedDocuments: updatedDocuments});

    } catch (error) {
      setLoading(false);
      const err = error as AxiosError;
      console.log(err);
      if(err.response && err.response.status === 400) {
        const errorData = err.response?.data as IApiErrors;
        setErrorMsg("Erreur: " + errorData.message);
      } else {
        setErrorMsg("Une erreur technique est survenue ");
      }
    }
  }

  const onEventMessage = (message: any, type: string) => {
    if(type === 'upload') {
      setDocumentUploaded(message);
      setIsShowModal(false);
      setShowUploadButtonOnModal(false);
       const updatedDocuments = proposition?.documents ?  [...proposition?.documents] as IDocumentDetail[] : [];
      const index = updatedDocuments.findIndex(el => el.documentId === documentId);
      updatedDocuments.splice(index, 1, message);
      dispatch({type: 'UPDATE_UPDATED_DOCUMENTS', updatedDocuments: updatedDocuments});
    }
  }


  const onDownloadDocument = async () => {
    try {
      const token = jwtToken!.accessToken;
      const res = await downloadUploadedDocument(token, proposition!.propositionId, documentId);
      const content = new Blob([res.data], {type: res.headers['content-type']});
      const filename = getFilename(res.headers);
      const file = new File([content], filename);
      setFile(file);
      setOpenPreviewFile(true);
      setShowUploadButtonOnModal(false);
      dispatch({type: 'SHOW_MODAL', showModal: true});
    } catch (error) {
      setLoading(false);

      const err = error as AxiosError;
      console.log(err);
      if(err.response && err.response.status === 400) {
        const errorData = err.response?.data as IApiErrors;
        setErrorMsg("Erreur: " + errorData.message);
      } else {
        setErrorMsg("Une erreur technique est survenue ");
      }
    }
  }

  const onDeleteDocument = () => {
    setDocumentUploaded(null);
  }

   const onCenterAction = () => {
    navigate({
      pathname: APP_URLS.listInvalidDocumentPage,
      search: `?id=${proposition!.propositionId}`,
    });
  }


  return (         
      <form style={{width: '100%'}}>  
        <h2 className="card-title bleu mb-md">{documentUploaded ? 'Téléchargé avec succès : ' : 'Veuillez télécharger le document démandé pour valider votre dossier :'} </h2>
        <div className='form-row'>
            <div className='form-group mw-70'>
              {errorFileTypeMsg && <p className='text blanc p-sm bg-fushia'>{ERROR_MESSAGES.fileTypeMsg}</p> }
              {errorFileSizeMsg && <p className='text blanc p-sm bg-fushia'>{ERROR_MESSAGES.fileSizeMsg}</p> }
            </div>
            <div className='form-group mw-30'></div>
        </div> 

        {
          documentUploaded ? 
          <div>
            <ListOfFileUploaded 
              fileName={documentUploaded.name}
              onDownloadDocument={onDownloadDocument}
              onDeleteDocument={onDeleteDocument}
            />
            {documentUploaded.status === "Invalide" && <p className='text bg-menthe blanc m-y-md p-sm mw-70 bg-orange'>
              {invalidMessage} 
              <span className='link' onClick={onDeleteDocument} role='button' tabIndex={0} onKeyDown={(e) => handleKeyDown(e)}>Souhaitez-vous télécharger un nouveau fichier?</span>
            </p>}
          </div>
        
          :
          <div>
            <p className='text fw-medium'>Votre {PROPOSITION_DOC_TYPES.find(el => el.code === documentTypeCode)!.label || "document"} :</p>
            <div className="form-row va-center">
              <div className='form-group mw-30'>
                <MgpInputFileUpload
                id="attachId2"
                onChange={(e) => handleFileChange(e)}
                register={register} 
                errors={errors}
                required={false}
                onClick={(e)=> e.currentTarget.value = ''}
                />
              </div>
              {
                isDesktop && <div className="form-group mw-5 ta-center"><p className='fz-lg'>ou</p></div>
              }
              {isDesktop && 
              <div className='form-group mw-30'>
                <UploadFromPhoneButton onClick={() => showQrCodeNotPrincipal()}/> 
              </div>}
            </div>
       
          </div>
        }         
      
    

        {openPreviewFile&&file&&<UploadFilePreviewModal file={file} onUploadAction={onUploadAction} isOpen={openPreviewFile} onCloseModal={() => {setOpenPreviewFile(false);  dispatch({type: 'SHOW_MODAL', showModal: false});}} showButton={showUploadButtonOnModal}/>} 

        <StickButtonsBloc 
            showNextButton={false} 
            showPreviousButton={false}  
            showCenterButton={true}
            centerAction={onCenterAction}
            centerButtonName="Retourner à la page de documents"
          />
     
        {isShowModal && <QrCodeModal isOpen={isShowModal} onShowQrCode={showQrCodeModal} onCloseModal={closeModal} docCode={documentTypeCode} docId={documentId} onEventMessage={onEventMessage} /> }
        {(isSubmitting || loading) && <LoaderModal hasMessage={false}/>}
        <div>
          {errorMsg && <MgpMessage type="danger" message={errorMsg} hasCloseBtn={true}/>}
        </div>
      </form>
  )
}
